import * as React from 'react'

import { Box, Button, type IllustrationType, Text } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface CardCreationConfirmationModalProps {
  icon?: IllustrationType
  title: string
  description: string
  warningMessage?: string
  onSubmit: () => void
  onClose: () => void
  submitDisabled: boolean
}

export const CardCreationConfirmationModal = ({
  icon,
  title,
  description,
  onSubmit,
  onClose,
  warningMessage,
  submitDisabled,
}: CardCreationConfirmationModalProps) => {
  const footer = (
    <Box flexDirection="row" gap="s8">
      <Button onClick={onClose} type="secondary">
        {i18n.t('expenses_v2.list.actions.modal.cancel')}
      </Button>
      <Button disabled={submitDisabled} onClick={onSubmit}>
        {i18n.t('expenses_v2.list.actions.modal.create_card')}
      </Button>
    </Box>
  )

  return (
    <Modal
      illustration={icon}
      title={title}
      description={description}
      footer={footer}
      onClose={onClose}
    >
      {!!warningMessage && (
        <Box
          background="champagne400"
          padding="s16"
          maxWidth="s400"
          borderRadius={{ all: 'abs008' }}
        >
          <Text.Normal>{warningMessage}</Text.Normal>
        </Box>
      )}
    </Modal>
  )
}
